import { Component, HostListener, OnInit } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { DashboardModel } from './model/dashboard-model';
import { DashboardProfileService, UserProfile } from './service/dashboard-profile.service';
import { DoodlesService } from '../doodles/doodles.service';
import { DoodleModel } from '../doodles/doodle-model';
import { AuthenticationService } from '@wap/core/libs/authentication';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit {
  public currentUser = {} as UserProfile;
  public model = {} as DashboardModel;
  public doodleModel = {} as DoodleModel;

  constructor(
      private authenticationService: AuthenticationService,
      private dashboardService: DashboardService,
      private dashboardProfileService: DashboardProfileService,
      private doodlesService: DoodlesService
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.dashboardService.updateViewVariables(event.target.innerWidth);
  }

  ngOnInit() {
    this.loadData();
  }

  private loadData() {
    this.dashboardProfileService.getCurrentUser().subscribe((user) => {
      if (!this.authenticationService.authenticated()) {
        return;
      }
      this.dashboardService.init();
      this.model = this.dashboardService.dashboardModel;
      this.doodleModel = this.doodlesService.doodleModel;
      this.currentUser = {
        name: user.userName ?  user.userName : this.authenticationService.subject(),
        fullName: user.otherAttributes && user.otherAttributes.name,
        isGuest: user.isGuest
      };

      this.dashboardService.updateViewVariables();
    });
  }

  public openApp(app): void {
    window.open(app.route, '_self');
  }

  public isAcademicLicense(): boolean {
    return this.model.license && this.model.license.licenseInfoMap && this.model.license.licenseInfoMap.academic;
  }

  public trackByFn(index, app): any {
    return app ? app.id : index;
  }

  public handleProfileSingOut(): void {
    this.dashboardProfileService.signOut();
  }

  public isMobile(): boolean {
    return this.dashboardService.isMobile();
  }

  showHeader(): boolean {
    return !!Object.keys(this.model).length;
  }
}
